import { render, staticRenderFns } from "./OrderGeneral.vue?vue&type=template&id=f5ccb6fe"
import script from "./OrderGeneral.vue?vue&type=script&lang=js"
export * from "./OrderGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports